import instObj from '@/backend/axios-instances'

const resource = "/cutsheets"
const instance = instObj.baseInstance

export default {
  post(data) {
    return instance.post(resource, data);
  },
  get(parameters) {
    return instance.get(resource, { params: parameters });
  }
}
